"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Sounds;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CommonContentModule = _interopRequireDefault(require("../CommonContent.module.scss"));

var _SoundsModule = _interopRequireDefault(require("./Sounds.module.scss"));

var _Slider = _interopRequireDefault(require("../../../../../inputElements/Slider/Slider"));

var _Checkbox = _interopRequireDefault(require("../../../../../inputElements/Checkbox/Checkbox"));

var _ListElement = _interopRequireDefault(require("../../../../../common/ListElement/ListElement"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Sounds(_ref) {
  var className = _ref.className;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSoundFxDisabled = _useState2[0],
      setIsSoundFxDisabled = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isBgMusicDisabled = _useState4[0],
      setIsBgMusicDisabled = _useState4[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentModule.default.content, _SoundsModule.default.content, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.soundFx
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    className: _SoundsModule.default.listElement
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.label
  }, "Sound FX"), " ", /*#__PURE__*/_react.default.createElement(_Slider.default, {
    className: _SoundsModule.default.slider,
    initialValue: 100,
    inStepsOfTen: true,
    isDisabled: isSoundFxDisabled
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "soundFx",
    className: _SoundsModule.default.checkBox,
    checked: isSoundFxDisabled,
    onChange: function onChange(event) {
      return setIsSoundFxDisabled(event === null || event === void 0 ? void 0 : event.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.stateText
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "soundFx"
  }, "Off"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.bgMusic
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    className: _SoundsModule.default.listElement
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.label
  }, "BG Music"), " ", /*#__PURE__*/_react.default.createElement(_Slider.default, {
    className: _SoundsModule.default.slider,
    initialValue: 100,
    inStepsOfTen: true,
    isDisabled: isBgMusicDisabled
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "bgMusic",
    className: _SoundsModule.default.checkBox,
    checked: isBgMusicDisabled,
    onChange: function onChange(event) {
      return setIsBgMusicDisabled(event === null || event === void 0 ? void 0 : event.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _SoundsModule.default.stateText
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "bgMusic"
  }, "Off"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentModule.default.buttonFooter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.OPTION
  }, "Reset"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.OPTION
  }, "Ok")));
}